'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InitializeInactiveThumbnails = exports.ProductThumbnail = exports.ACTIVE_THUMBNAILS = exports.ATTR_UPSELL = exports.ATTR_INITIALIZED = exports.CLASS_HIDDEN = exports.CLASS_ENGAGED = exports.CLASS_SUCCESS = exports.CLASS_DISABLED = exports.PRODUCT_COMPARE_MONEY = exports.PRODUCT_MONEY = exports.PRODUCT_THUMBNAIL_SELECT = exports.THUMBNAIL_LINK = exports.SELECTOR_THUMB_ADD_BTN = exports.SELECTOR_THUMBNAIL = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _pcSlateTools = require('@process-creative/pc-slate-tools');

var _Swatch2 = require('./../swatch/Swatch');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//Selectors
var SELECTOR_THUMBNAIL = exports.SELECTOR_THUMBNAIL = '[data-product-thumbnail]'; /*
                                                                                   *  Product Thumbnail
                                                                                   *    Contains scripts for the Product Thumbnail
                                                                                   *
                                                                                   *  Version
                                                                                   *    1.0.0 - 2020/07/02
                                                                                   */

var SELECTOR_THUMB_ADD_BTN = exports.SELECTOR_THUMB_ADD_BTN = '[data-product-thumbnail-add-btn]';
var THUMBNAIL_LINK = exports.THUMBNAIL_LINK = '[data-product-thumbnail-link]';
var PRODUCT_THUMBNAIL_SELECT = exports.PRODUCT_THUMBNAIL_SELECT = '[data-product-thumbnail-select]';

//Money Selectors
var PRODUCT_MONEY = exports.PRODUCT_MONEY = '[data-product-money]';
var PRODUCT_COMPARE_MONEY = exports.PRODUCT_COMPARE_MONEY = '[data-product-compare-money]';

//Classes
var CLASS_DISABLED = exports.CLASS_DISABLED = 'is-disabled';
var CLASS_SUCCESS = exports.CLASS_SUCCESS = 'is-success';
var CLASS_ENGAGED = exports.CLASS_ENGAGED = 'is-engaged';
var CLASS_HIDDEN = exports.CLASS_HIDDEN = 'is-hidden';

var ATTR_INITIALIZED = exports.ATTR_INITIALIZED = 'data-initialized';
var ATTR_UPSELL = exports.ATTR_UPSELL = 'data-cart-upsell';

var ACTIVE_THUMBNAILS = exports.ACTIVE_THUMBNAILS = [];

var ProductThumbnail = exports.ProductThumbnail = function (_Swatch) {
  (0, _inherits3.default)(ProductThumbnail, _Swatch);

  function ProductThumbnail(container) {
    (0, _classCallCheck3.default)(this, ProductThumbnail);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ProductThumbnail.__proto__ || Object.getPrototypeOf(ProductThumbnail)).call(this, container));

    _this.container = container;

    _this.links = container.find(THUMBNAIL_LINK);
    _this.addBtn = container.find(SELECTOR_THUMB_ADD_BTN);
    _this.selectBtn = container.find(PRODUCT_THUMBNAIL_SELECT);
    _this.money = container.find(PRODUCT_MONEY);

    _this.isUpsell = container.attr(ATTR_UPSELL);
    return _this;
  }

  (0, _createClass3.default)(ProductThumbnail, [{
    key: 'getSelectedVariantId',
    value: function getSelectedVariantId() {
      this.currentId = !this.selector.val() ? this.selector.find('option:selected').val() : this.selector.val();
      //Resolve issue with select boxes losing their selectedIndex
      if (!this.currentId) {
        this.container.find('select').each(function (i, e) {
          var self = (0, _jquery2.default)(e);
          var opt = self.find('option[selected]');
          if (!opt || !opt.length) return;
          self.val(opt.attr('value'));
        });
      }
      return this.currentId;
    }
  }, {
    key: 'shouldUseEvents',
    value: function shouldUseEvents() {
      return false;
    }
  }, {
    key: 'onVariantChanged',
    value: function onVariantChanged(variant, id) {
      var price = variant.price,
          compare_at_price = variant.compare_at_price,
          product = variant.product;


      this.updateButton(variant, id);
      this.selectBtn.addClass(CLASS_HIDDEN);

      // //Adjust Price Display
      // let money = this.container.find(PRODUCT_MONEY);
      // if(!price || price <= 0) {
      //   money.removeAttr('data-money');//Stops any currency converters attempting to convert.
      //   money.html('FREE');//TODO: Make this not hard coded.
      // } else {
      //   money.attr('data-money', price);
      //   money.html(printMoney(price));
      // }

      this.links.each(function (i, e) {
        return (0, _jquery2.default)(e).attr('href', product.url + '?variant=' + id);
      });

      //Adjust compare price display
      var compare = this.container.find(PRODUCT_COMPARE_MONEY);
      if (!compare_at_price || compare_at_price <= price) {
        compare.removeAttr('data-money');
        compare.html('');
      } else {
        compare.attr('data-money', compare_at_price);

        var x = '\n        <span\n          class="o-product-thumbnail__price-compare o-product-pricing__compare"\n          data-currency\n          data-money="' + compare_at_price + '"\n        >\n          ' + (0, _pcSlateTools.printMoney)(compare_at_price) + '\n        </span>\n      ';
        compare.html(x);
      }
    }
  }, {
    key: 'cancelEvents',
    value: function cancelEvents(e) {
      e.preventDefault(), e.stopPropagation();
    }
  }, {
    key: 'addProduct',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(e) {
        var _this2 = this;

        var id, variant;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.cancelEvents(e);

                id = this.getSelectedVariantId();
                variant = this.getVariantData(id);

                //Disable

                this.addBtn.attr('disabled', 'disabled');
                this.addBtn.addClass(CLASS_DISABLED);

                _context.prev = 5;
                _context.next = 8;
                return (0, _pcSlateTools.addToCart)(id);

              case 8:
                _context.next = 15;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](5);

                //Error, show error, enable buttons hide loader
                console.error('Failed to add to cart.');
                this.updateButton(variant, id);
                return _context.abrupt('return');

              case 15:

                //No error, enable buttons, hide disable class, hide option box
                this.addBtn.removeAttr('disabled', 'disabled');
                this.addBtn.removeClass(CLASS_DISABLED);
                this.updateAvailableSwatches();
                this.addBtn.html('' + (0, _pcSlateTools.t)('products.product.added_to_cart'));
                this.addBtn.addClass(CLASS_SUCCESS);
                setTimeout(function () {
                  return _this2.updateButton(variant, id);
                }, 3500);

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 10]]);
      }));

      function addProduct(_x) {
        return _ref.apply(this, arguments);
      }

      return addProduct;
    }()
  }, {
    key: 'updateButton',
    value: function updateButton(variant, id) {
      //Adjust the add to cart button based on QTY available and in cart
      var available = variant.available,
          inventory_policy = variant.inventory_policy,
          inventory_management = variant.inventory_management,
          inventory_quantity = variant.inventory_quantity,
          price = variant.price;


      var inCart = (0, _pcSlateTools.getCountOfVariantInCart)(id);
      this.addBtn.removeClass(CLASS_SUCCESS);
      this.addBtn.removeClass(CLASS_HIDDEN);

      var priceFormatted = (0, _pcSlateTools.printMoney)(price).replace('.00', '');
      if (this.isUpsell) this.money.html((0, _pcSlateTools.printMoney)(price));

      var label = (0, _pcSlateTools.t)('products.product.add_to_cart') + ' <span data-product-money data-currency data-money="' + price + '">' + priceFormatted + '</span>';

      if (available) {

        if (inventory_policy != 'continue' && inventory_management != null && inventory_quantity - inCart <= 0) {
          available = false;
          label = '' + (0, _pcSlateTools.t)('products.product.all_in_cart');
          this.addBtn.attr('disabled', 'disabled');
          this.addBtn.addClass(CLASS_DISABLED);
        } else {

          this.addBtn.removeAttr('disabled', 'disabled');
          this.addBtn.removeClass(CLASS_DISABLED);
        }
      } else {
        label = (0, _pcSlateTools.t)('products.product.sold_out');
        this.addBtn.attr('disabled', 'disabled');
        this.addBtn.addClass(CLASS_DISABLED);
      }
      if (!this.addBtn.hasClass('is-add-button')) {
        this.addBtn.html(label);
      }
    }
  }, {
    key: 'attachEvents',
    value: function attachEvents() {
      var _this3 = this;

      (0, _get3.default)(ProductThumbnail.prototype.__proto__ || Object.getPrototypeOf(ProductThumbnail.prototype), 'attachEvents', this).call(this);

      if (ACTIVE_THUMBNAILS.indexOf(this) === -1) ACTIVE_THUMBNAILS.push(this);

      this.container.attr(ATTR_INITIALIZED, 'true');

      this.boundAddProduct = function (e) {
        return _this3.addProduct(e);
      };
      this.container.on('click', SELECTOR_THUMB_ADD_BTN, this.boundAddProduct);
    }
  }, {
    key: 'detachEvents',
    value: function detachEvents() {
      (0, _get3.default)(ProductThumbnail.prototype.__proto__ || Object.getPrototypeOf(ProductThumbnail.prototype), 'detachEvents', this).call(this);

      var i = ACTIVE_THUMBNAILS.indexOf(this);
      if (i !== -1) ACTIVE_THUMBNAILS.splice(i, 1);
      this.container.removeAttr(ATTR_INITIALIZED);

      if (this.boundAddProduct) this.container.off('click', SELECTOR_THUMB_ADD_BTN, this.boundAddProduct);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      var _this4 = this;

      this.detachEvents();
      Object.keys(this).forEach(function (e) {
        return delete _this4[e];
      });
    }
  }]);
  return ProductThumbnail;
}(_Swatch2.Swatch);

//Initializer.....


var InitializeInactiveThumbnails = exports.InitializeInactiveThumbnails = function InitializeInactiveThumbnails() {
  console.log('Thumbnails Initializing');

  [].concat(ACTIVE_THUMBNAILS).forEach(function (e) {
    if (e.container.length) return;
    e.destroy();
  });

  (0, _jquery2.default)(SELECTOR_THUMBNAIL).each(function (i, e) {
    var self = (0, _jquery2.default)(e);
    if (self.attr(ATTR_INITIALIZED)) return;
    var thumb = new ProductThumbnail(self);
  });
};

//On ready...
(0, _jquery2.default)(document).ready(function () {
  return InitializeInactiveThumbnails();
});

window.InitializeInactiveThumbnails = InitializeInactiveThumbnails;
window.getActiveThumbs = function () {
  return ACTIVE_THUMBNAILS;
};